import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../../auth/AuthContext.js'
import { Button, Card } from '../../components'
import { completeClassroomConnect } from '../../lib/classroom-connect.js'

export default function ClassroomConnectCallbackPage(): JSX.Element {
  const navigate = useNavigate()
  const { firebaseUser, status } = useAuth()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    if (status === 'loading') return
    let cancelled = false
    void (async () => {
      try {
        const idToken = await firebaseUser?.getIdToken()
        if (!idToken) throw new Error('Sign in again before connecting Classroom.')
        const returnTo = await completeClassroomConnect(idToken)
        if (!cancelled) navigate(returnTo, { replace: true })
      } catch (err) {
        if (!cancelled) {
          setErrorMessage(err instanceof Error ? err.message : 'Could not connect Classroom.')
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [firebaseUser, navigate, status])

  if (errorMessage) {
    return (
      <section aria-labelledby="classroom-callback-title">
        <Card>
          <h2 id="classroom-callback-title">Classroom connection failed</h2>
          <p role="alert">{errorMessage}</p>
          <Button type="button" variant="secondary" onClick={() => navigate('/teacher/classes')}>
            Back to classes
          </Button>
        </Card>
      </section>
    )
  }

  return (
    <section aria-labelledby="classroom-callback-title">
      <h2 id="classroom-callback-title">Connecting Google Classroom</h2>
      <p role="status" aria-live="polite">
        Finishing the secure connection…
      </p>
    </section>
  )
}
